/*! ES5-compatible Product Tabs behavior (no classes, no customElements) */
(function () {
  'use strict';

  // Smooth scrollBy poly (ES5) with easing
  function smoothScrollBy(delta, duration) {
    if (!duration) { window.scrollBy(0, delta); return; }
    var startY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var startT = Date.now();
    var endT = startT + duration;
    function ease(p){ return 1 - Math.pow(1 - p, 3); } // easeOutCubic
    var raf = window.requestAnimationFrame || function(cb){ return setTimeout(cb, 16); };
    function step(){
      var now = Date.now();
      var t = (now - startT) / duration; if (t < 0) t = 0; if (t > 1) t = 1;
      var y = startY + delta * ease(t);
      window.scrollTo(0, y);
      if (now < endT) raf(step);
    }
    raf(step);
  }

  function addEvent(el, type, handler, opts) {
    if (!el) return;
    if (el.addEventListener) { el.addEventListener(type, handler, !!opts && opts.capture); }
    else if (el.attachEvent) { el.attachEvent('on' + type, handler); }
  }

  function eachNode(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return root.querySelectorAll(sel); }

  // Keep viewport anchored on a reference element while DOM/layout changes happen.
  function anchorScrollLock(anchorEl, runner) {
    if (!anchorEl) { runner(function(){}); return; }
    var beforeTop = anchorEl.getBoundingClientRect().top;
    function restore() {
      var afterTop = anchorEl.getBoundingClientRect().top;
      var delta = afterTop - beforeTop;
      smoothScrollBy(delta, 800); // smooth correction
    }
    runner(function () {
      // double rAF to ensure styles apply before measurement
      if (window.requestAnimationFrame) {
        requestAnimationFrame(function(){ requestAnimationFrame(restore); });
      } else {
        setTimeout(restore, 0);
      }
    });
  }

  function initProductTabs(root) {
    var tab = qa(root, '.tab-title');
    var tabContents = q(root, '.tabs-contents');
    var tabContent = qa(root, '.tab-content');
    var link = qa(root, '.toggleLink');
    var readMore = qa(root, '[data-show-more-toogle]');
    var tabClose = qa(root, '.pdViewTab-close');

    var isVerticalPopup = (root.getAttribute('data-vertical') === 'sidebar');
    var isVerticalSidebarMobile = (root.getAttribute('data-vertical-mobile') === 'sidebar-mobile');

    function checkTabShowMore(id) {
      var panel = document.getElementById(id);
      if (!panel) return;
      var showBox = q(panel, '.tab-showMore');
      if (!showBox) return;
      var desMax = showBox.getAttribute('data-des-max');
      if (!desMax) return;
      var cont = q(panel, '.tab-description');
      if (!cont) cont = panel;
      var tabHeight = cont.scrollHeight;
      if (tabHeight < parseInt(desMax, 10)) {
        if (showBox && showBox.parentNode) {
          showBox.parentNode.removeChild(showBox);
        }
      }
    }

    function productTabCloseHandler(e) {
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);
      e.stopPropagation && e.stopPropagation();
      var icon = e.target || e.srcElement;
      var content = icon && icon.closest ? icon.closest('.toggle-content') : null;
      if (!content) return;
      var tgl = content.parentNode ? q(content.parentNode, '.toggleLink') : null;
      if (tgl) tgl.classList.remove('is-open');
      content.classList.remove('is-show');
      document.body.classList.remove('tab-popup-show');
    }

    function onBackgroundClick(e) {
      var tgt = e.target || e.srcElement;
      // ignore clicks inside an open panel
      var openInside = (tgt.closest && tgt.closest('toggle-content.is-show')) ? true : false;
      if (openInside) return;
      var openLink = document.querySelector('.toggleLink.is-open');
      if (openLink) openLink.classList.remove('is-open');
      var openPanel = document.querySelector('.toggle-content.is-show');
      if (openPanel) openPanel.classList.remove('is-show');
      document.body.classList.remove('tab-popup-show');
    }

    function tabActive(e) {
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);
      e.stopPropagation && e.stopPropagation();
      var target = e.currentTarget || e.target;
      var thisTitle = (target.closest && target.closest('.tab-title')) ? target.closest('.tab-title') : target;
      var id = thisTitle.getAttribute('aria-controls');
      if (!id) {
        var href = thisTitle.getAttribute('href') || '';
        id = href.replace('#', '');
      }
      var button_tab = document.querySelector('.an-horizontal-shaking');

      var anchorEl = thisTitle;
      anchorScrollLock(anchorEl, function (after) {
        if (!thisTitle.classList.contains('is-open')) {
          eachNode(tab, function (el) { el.classList.remove('is-open'); });
          thisTitle.classList.add('is-open');
          if (tabContents) tabContents.classList.add('is-show');
          if (button_tab) button_tab.classList.add('open-tab-content');
          eachNode(tabContent, function (el) {
            if (el.getAttribute('id') == id) el.classList.add('is-active');
            else el.classList.remove('is-active');
          });
        } else {
          thisTitle.classList.remove('is-open');
          if (button_tab && button_tab.classList.contains('open-tab-content')) {
            button_tab.classList.remove('open-tab-content');
          }
          if (tabContents) tabContents.classList.remove('is-show');
        }
        checkTabShowMore(id);
        after();
      });
    }

    function tabToggle(e) {
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);
      e.stopPropagation && e.stopPropagation();
      var target = e.currentTarget || e.target;
      var linkEl = (target.closest && target.closest('.toggleLink')) ? target.closest('.toggleLink') : target;
      var content = linkEl.parentNode ? linkEl.parentNode.nextElementSibling : null;
      if (!content) return;

      var anchorEl = linkEl;
      anchorScrollLock(anchorEl, function (after) {
        var width = window.innerWidth || document.documentElement.clientWidth;

        if (!linkEl.classList.contains('is-open')) {
          linkEl.classList.add('is-open');
          if (isVerticalPopup && width > 550 || isVerticalSidebarMobile && width <= 550 || linkEl.classList.contains('sidebar-mobile') && width <= 550) {
            content.classList.add('is-show');
            document.body.classList.add('tab-popup-show');
            after();
          } else {
            // mobile jQuery animation if present
            if (typeof window.jQuery !== 'undefined' && width <= 551 && linkEl.classList.contains('show-mobile')) {
              content.classList.add('is-show');
              try { window.jQuery(content).slideDown('slow', after); } catch (err) { after(); }
            } else {
              content.classList.add('is-show');
              after();
            }
          }
        } else {
          linkEl.classList.remove('is-open');
          if ((isVerticalPopup && width > 550) || (isVerticalSidebarMobile && width <= 550) || (linkEl.classList.contains('sidebar-mobile') && width <= 550)) {
            content.classList.remove('is-show');
            document.body.classList.remove('tab-popup-show');
            after();
          } else {
            if (typeof window.jQuery !== 'undefined' && (width <= 551 && linkEl.classList.contains('show-mobile'))) {
              try { window.jQuery(content).slideUp('slow', function(){ content.classList.remove('is-show'); after(); }); } catch (err) { content.classList.remove('is-show'); after(); }
            } else {
              content.classList.remove('is-show');
              after();
            }
          }
        }
      });
    }

    function readMoreReadLess(e) {
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);
      e.stopPropagation && e.stopPropagation();
      var target = e.target || e.srcElement;
      if (target && !target.hasAttribute('data-show-more-toogle')) {
        var host = target.closest && target.closest('[data-show-more-toogle]');
        if (host) target = host;
      }
      if (!target) return;

      var href = target.getAttribute('href') || '';
      var id = href.replace('#', '');
      var textShowMore = target.getAttribute('data-show-more-text');
      var textShowLess = target.getAttribute('data-show-less-text');
      var box = target.closest ? target.closest('.tab-showMore') : null;
      var desMax = box ? box.getAttribute('data-des-max') : '';

      if (target.classList.contains('is-less')) {
        if (box) box.classList.remove('is-less');
        target.classList.remove('is-less');
        if (box) box.classList.add('is-show');
        target.classList.add('is-show');
        target.innerText = textShowMore;
        var el = document.getElementById(id); if (el) el.style.maxHeight = desMax + 'px';
        if (tabContents && tabContents.scrollIntoView) tabContents.scrollIntoView(true);
      } else {
        if (box) box.classList.remove('is-show');
        target.classList.remove('is-show');
        if (box) box.classList.add('is-less');
        target.classList.add('is-less');
        target.innerText = textShowLess;
        var el2 = document.getElementById(id); if (el2) el2.style.maxHeight = 'unset';
      }
    }

    // Bind events
    eachNode(tab, function (el) { addEvent(el, 'click', tabActive); });
    eachNode(link, function (el) { addEvent(el, 'click', tabToggle); });
    eachNode(tabClose, function (el) { addEvent(el, 'click', productTabCloseHandler); });
    addEvent(document, 'click', function (e) {
      var tgt = e.target || e.srcElement;
      var isMore = (tgt && (tgt.hasAttribute && tgt.hasAttribute('data-show-more-toogle'))) || (tgt.closest && tgt.closest('[data-show-more-toogle]'));
      var isClose = (tgt && (tgt.classList && tgt.classList.contains('pdViewTab-close'))) || (tgt.closest && tgt.closest('.pdViewTab-close'));
      if (isMore) readMoreReadLess(e);
      else if (isClose) productTabCloseHandler(e);
    });

    if (isVerticalPopup || isVerticalSidebarMobile) {
      var bg = document.querySelector('.background-overlay');
      if (bg) addEvent(bg, 'click', onBackgroundClick);
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll('product-tab');
    for (var i = 0; i < nodes.length; i++) initProductTabs(nodes[i]);
  }

  if (document.readyState === 'loading') {
    addEvent(document, 'DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();  